import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Dropdown, FormCheck, FormControl, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import '../../../styles/Forms.css';
import { HHIEButton } from '../../utility/HHIEButton';
import Loading from '../../utility/Loading';
import useFetch from '../../utility/useFetch';
// REFERENCE OF OBJ STORAGE
// const pocUser = {
//     isPOCUser: true,
//     memberID: user.member_ID,
//     sfid: user.sfid,
//     userID: user.userID,
//     passwordIsTemporary: user.passwordIsTemporary
// }
export function POCMemberForm() {
    const [user, setUser] = useState({
        isPOCUser: true,
        memberID: 0,
        sfid: "",
        userID: "",
        passwordIsTemporary: true
    });
    const [member, setMember] = useState({
        id: "",
        npi: "",
        firstName: "",
        middleName: "",
        lastName: "",
        passStatus: null,
        stateLicense: "",
        abbrTitle: "",
        specialty: "",
        dob: "",
        email: "",
        isPOC: false,
        jobTitle: ""
    });
    const [isProvider, setIsProvider] = useState();
    const [specialties] = useFetch('api/Registration/getSpecialties');

    useEffect(() => {
        try {
            const userFromStorage = JSON.parse(sessionStorage.getItem("user"));
            setUser({
                isPOCUser: userFromStorage.isPOCUser,
                memberID: userFromStorage.memberID,
                sfid: userFromStorage.sfid,
                userID: userFromStorage.userID,
                passwordIsTemporary: userFromStorage.passwordIsTemporary
            });
            const fetchData = async () => {
                const memberFromSFOrDB = await fetch('api/POCUser/retrieve-member-info/' + userFromStorage.sfid)
                .then((res) => res.json())
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                var truncatedDob = memberFromSFOrDB.dob.slice(0, 10);

                setMember({
                    id: memberFromSFOrDB.id,
                    npi: memberFromSFOrDB.npi,
                    firstName: memberFromSFOrDB.firstName,
                    middleName: memberFromSFOrDB.middleName,
                    lastName: memberFromSFOrDB.lastName,
                    passStatus: memberFromSFOrDB.passStatus,
                    stateLicense: memberFromSFOrDB.stateLicense,
                    abbrTitle: memberFromSFOrDB.abbrTitle,
                    specialty: memberFromSFOrDB.specialty,
                    dob: truncatedDob,
                    email: memberFromSFOrDB.email,
                    isPOC: memberFromSFOrDB.isPOC,
                    jobTitle: memberFromSFOrDB.jobTitle
                });
                setIsProvider(memberFromSFOrDB.passStatus.type === "Provider");
            }
            fetchData();
            // const [member, setMember] = useState(useFetch('api/POCUser/retrieve-member-info/' + user.sfid));
        } catch (ex) {
            console.log(ex);
        }
    }, []);

    useEffect(() => {
        if (member.npi.length === 10) {
            fetch('api/Registration/getMemberData/' + member.npi)
            .then((res) => res.json())
                .then((data) => {
                    if (data.errors !== null && data.errors !== "") alert(data.errors)
                    setMember(data.message)
                });
        }
    }, [member.npi]);

    const updateMember = e => {
        setMember({
          ...member,
          [e.target.name]: e.target.value
        });
      };

    const submitDataToDB = async () => {
        
        const formData = new FormData();
        formData.append("mid", user.memberID);
        formData.append("sfid", user.sfid);
        formData.append("Provider", member.passStatus.type === "Provider" ? "true" : "false");
        formData.append("firstName", member.firstName);
        formData.append("middleName", member.middleName);
        formData.append("lastName", member.lastName);
        formData.append("npi", member.npi);
        formData.append("stateLicense", member.stateLicense);
        formData.append("abbrTitle", member.abbrTitle);
        formData.append("specialty", member.specialty);
        formData.append("dob", member.dob);
        formData.append("email", member.email);
        formData.append("jobTitle", member.jobTitle);

        const requestOptions = {
            method: 'POST',
            body: formData
        }
        const success = await fetch('api/POCUser/savePOCData', requestOptions)
            .then((response) => response.json())
            .then((json) => {
                if (json.errors !== null && json.errors !== "") alert(json.errors)
                return json.message
            });

        if (user.memberID === 0) {
            fetch('api/POCUser/get-poc-mid/' + user.sfid)
            .then((response) => response.json())
            .then((memberId) => {
                user.memberID = memberId;
                setUser(user);
                sessionStorage.setItem("user", JSON.stringify(user));
                window.location.href = "/registration-dashboard";
            });
        }
    }

    return (
        <>
        {!member && <Loading message="Loading your infomation, please wait. . ."/>}
        {member &&
            <Container style={{ padding: "15px" }}>
                <Row style={{ padding: "4px" }}>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="legal-name-tip">Please select either provider or staff</Tooltip>}
                    >
                        <Col className="justify-content-start" sm={2} style={{ padding: "4px" }}>
                            <div className="justify-content-start">
                                <FormCheck
                                    label="Provider"
                                    name="staff-type"
                                    type="checkbox"
                                    id="type-provider-radio"
                                    checked={isProvider}
                                    onChange={(e) => setIsProvider(e.target.checked)}
                                />
                            </div>
                            <div className="justify-content-start">
                                <FormCheck
                                    label="Staff Member"
                                    name="staff-type"
                                    type="checkbox"
                                    id="type-staff-radio"
                                    checked={!isProvider}
                                    onChange={(e) => setIsProvider(e.target.checked)}
                                />
                            </div>
                        </Col>
                    </OverlayTrigger>
                    <Col className="d-flex justify-content-start" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>First Name</div>
                        <FormControl
                            required
                            type="text"
                            placeholder="First Name"
                            // defaultValue={member.firstName}
                            value={member.firstName}
                            // id="firstName"
                            name="firstName"
                            // aria-label="firstName"
                            // aria-describedby="firstName"
                            onChange={updateMember}
                        />
                    </Col>
                    <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>Middle Name</div>
                        <FormControl
                            type="text"
                            placeholder="Middle Name"
                            // defaultValue={member.middleName}
                            value={member.middleName}
                            // id="middleName"
                            name="middleName"
                            // aria-label="middleName"
                            // aria-describedby="middleName"
                            onChange={updateMember}
                        />
                    </Col>
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>Last Name</div>
                        <FormControl
                            required
                            type="text"
                            placeholder="Last Name"
                            // defaultValue={member.lastName}
                            value={member.lastName}
                            // id="lastName"
                            name="lastName"
                            // aria-label="lastName"
                            // aria-describedby="lastName"
                            onChange={updateMember}
                        />
                    </Col>
                </Row>
                <Row style={{ padding: "4px" }}>
                    
                    {isProvider ?
                        <>
                            <Col className="d-flex justify-content-center" style={{ padding: "4px" }} >
                                <div className="d-flex justify-content-center">
                                    <div style={{ paddingRight: "5px" }}>Provider NPI</div>
                                    <FormControl
                                        required
                                        type="text"
                                        placeholder="Provider NPI"
                                        // defaultValue={member.npi}
                                        value={member.npi}
                                        maxLength="10"
                                        name="npi"
                                        //id="npi"
                                        //aria-label="npi"
                                        //aria-describedby="npi"
                                        onChange={updateMember}
                                        onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                                    />
                                </div>
                            </Col>
                            <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                                <div className="justify-content-end" style={{ paddingRight: "5px" }}>State License Number</div>
                                <FormControl
                                    className="justify-content-end"
                                    type="text"
                                    placeholder="State License Number"
                                    // defaultValue={member.stateLicense}
                                    value={member.stateLicense}
                                    // id="stateLicense"
                                    name="stateLicense"
                                    // aria-label="stateLicense"
                                    // aria-describedby="stateLicense"
                                    onChange={updateMember}
                                />
                            </Col>
                        </>
                        :
                        <>
                            <Col></Col>
                            <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                                <div style={{ paddingRight: "5px" }}>State License Number</div>
                                <FormControl
                                    type="text"
                                    placeholder="State License Number"
                                    // defaultValue={member.stateLicense}
                                    value={member.stateLicense}
                                    // id="stateLicense"
                                    name="stateLicense"
                                    // aria-label="stateLicense"
                                    // aria-describedby="stateLicense"
                                    onChange={updateMember}
                                />
                            </Col>
                        </>
                    }
                </Row>
                <Row style={{ padding: "4px" }}>
                    {isProvider ?
                        <>
                            <Col sm={2} style={{ padding: "4px" }}></Col>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip id="abbr-title-tip">Examples include: MD, APRN, ...</Tooltip>}
                            >
                                <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                                    <div className="d-flex justify-content-center">
                                        <div style={{ paddingRight: "5px" }}>Abbreviated Title</div>
                                        <FormControl
                                            type="text"
                                            placeholder="Abbreviated Title"
                                            // defaultValue={member.abbrTitle}
                                            value={member.abbrTitle}
                                            // id="abbrTitle"
                                            name="abbrTitle"
                                            // aria-label="abbrTitle"
                                            // aria-describedby="abbrTitle"
                                            maxLength="4"
                                            onChange={updateMember}
                                        />
                                    </div>
                                </Col>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip id="specialty-tip">Please select any that apply</Tooltip>}
                            >
                                <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                                    <div style={{ paddingRight: "5px" }}>Provider Specialty</div>
                                    <Dropdown
                                        id="p-type-dropdown"
                                        style={{ paddingLeft: "4px" }}
                                    >
                                        <DropdownToggle
                                            className="table-button"
                                            id="dropdown-specialty-button"
                                            variant="light"
                                            style={{ textAllign: "right", paddingBottom: "5" }}
                                        >{member.specialty !== null ? member.specialty : "Choose one or more specialties"}</DropdownToggle>
                                        <DropdownMenu
                                            style={{ maxHeight: "200px", overflowY: "scroll" }}
                                        >
                                            {(specialties !== null) ? specialties.map((value, index) => (
                                                <Dropdown.Item
                                                    key={index}
                                                    eventKey={value}
                                                    type="radio"
                                                    value={value}
                                                    active={member.specialty}
                                                    name="specialty"
                                                    onSelect={updateMember}
                                                >
                                                    {value}
                                                </Dropdown.Item>
                                            ))
                                                : <></>}
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </OverlayTrigger>
                        </>
                        : <></>
                    }
                </Row>
                {(isProvider && member !== null && member.npi !== "" && member.passStatus.npiPassStatus === "FAIL") ?
                    <Row>
                        <Col sm={2}></Col>
                        <Col>
                            <Alert variant="danger">{member.passStatus.npiComment}
                            </Alert>
                        </Col>
                        <Col></Col>
                    </Row> :
                    <></>}
                <Row style={{ padding: "4px" }}>
                    {!isProvider ?
                        <>
                            <Col sm={2}></Col>
                            <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                                <div style={{ paddingRight: "5px" }}>Staff Job Title</div>
                                <FormControl
                                    type="text"
                                    placeholder="Staff Job Title"
                                    defaultValue={member.jobTitle}
                                    // id="jobTitle"
                                    name="jobTitle"
                                    // aria-label="jobTitle"
                                    // aria-describedby="jobTitle"
                                    onChange={updateMember}
                                />
                            </Col>
                        </>
                        : <></>
                    }
                </Row>
                <Row style={{ padding: "4px" }}>
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }} sm="4">
                        <div style={{ paddingRight: "5px" }}>Date of Birth</div>
                        <FormControl
                            required
                            type="date"
                            placeholder="Date of Birth"
                            // defaultValue={member.dob}
                            value={member.dob}
                            // id="dob"
                            name="dob"
                            onChange={updateMember}
                        />
                    </Col>
                    <Col sm="2"></Col>
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>Email Address</div>
                        <FormControl
                            required
                            type="text"
                            placeholder="Email Address"
                            defaultValue={member.email}
                            // id="email"
                            name="email"
                            // aria-label="email"
                            // aria-describedby="email"
                            onChange={updateMember}
                        />
                    </Col>
                </Row>
                <Row className="justify-content-sm-center" style={{ padding: "15px" }}>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="solutions-tip">Your Organization may have limited access to these based on subscription</Tooltip>}
                    >
                        <Col className="d-flex justify-content-center" style={{ padding: "4px" }} sm={7}>
                            <div>Services, Solutions and Access</div>
                            <FormCheck
                                inline
                                label="Community Health Record"
                                name="access"
                                type="checkbox"
                                id="chr-access-check"
                            />
                            <FormCheck
                                inline
                                label="Referrals"
                                name="access"
                                type="checkbox"
                                id="referrals-check"
                            />
                            <FormCheck
                                inline
                                label="Direct Secure Messaging"
                                name="access"
                                type="checkbox"
                                id="dsm-check"
                            />
                            <FormCheck
                                inline
                                label="Notify"
                                name="access"
                                type="checkbox"
                                id="notify-check"
                            />
                        </Col>
                    </OverlayTrigger>
                </Row>
                <div className="d-flex justify-content-center" style={{ padding: "4px" }}>
                    <HHIEButton
                        id="submit-btn"
                        className="style-btns"
                        title="Submit"
                        onClick={submitDataToDB}
                    />
                </div>
            </Container>
        }
        </>
    );
}